import { useSignalmizely } from "./useSignalmizely.js";
import { useFlagData } from "./useFlagData.js";
export function useFlagVariation(flagKey, options = {}) {
    const helpers = useSignalmizely();
    const { data, isLoading, error } = useFlagData(flagKey, (flagKey, options) => helpers.flagVariation(flagKey, options), options);
    return {
        variation: data,
        isLoading,
        error,
    };
}
